export const LOCALES_FROM_API = {
  'es-ES': 'es',
  'en-GB': 'en',
  'de-DE': 'de',
  'fr-FR': 'fr',
  'it-IT': 'it',
  'pt-PT': 'pt',
  'ca-ES': 'ca',
}

export const LOCALES_TO_API = Object.entries(LOCALES_FROM_API)
  .map(locale => ({ [locale[1]]: locale[0] }))
  .reduce((obj, locale) => ({ ...obj, ...locale }), {})
